import { v4 as uuidv4 } from 'uuid';

export const getOrGenerateGUID = (): string => {
  const storedGUID = localStorage.getItem('user_guid');
  if (storedGUID) return storedGUID;

  const newGUID = uuidv4();
  localStorage.setItem('user_guid', newGUID);
  return newGUID;
};

export const setGUID = (guid: string) => {
  localStorage.setItem('user_guid', guid);
  return guid;
}
